import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { applySavedTheme } from '@evogard/ui';
import { buildRouter } from './routes.js';
import './styles.css';

/*
 * O tema, ANTES de o React montar.
 *
 * Depois de a página pintar, a troca vira um flash — o defeito que faz uma
 * interface escura parecer malfeita mesmo estando certa. O que se aplica aqui é
 * o eco em `localStorage`; a preferência do servidor chega uma requisição depois
 * e tem a palavra final, na tela de preferências.
 */
applySavedTheme();

const client = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

const router = buildRouter(client);

const root = document.getElementById('raiz');
if (!root) throw new Error('Elemento #raiz não encontrado.');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
